import { IconResearchAndDiscovery } from "../../../assets/icons/svgr";

function Header() {
  return (
    <div className="header">
      <IconResearchAndDiscovery
        style={{
          height: "50px",
          width: "50px",
          color: "#fff"
        }}
      />
      Research & Discovery
    </div>
  );
}

export default Header;
